import { ActionTypes } from "./types";

let INITIAL_STATE = {
  loading: false,
  success: false,
  error: null,
  data: []
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
